
































































































import { Component, Mixins } from "vue-property-decorator";
import OutsideView from "./OutsideView.vue";
import viewMetaMixin from "@/mixins/viewMetaMixin";
import onLocaleChangeMixin from "@/mixins/onLocaleChangeMixin";
import { IPlatformInfo } from "@/entities";
import i18n from "../../i18n";

@Component({
  components: {
    OutsideView,
  },
})
export default class About extends Mixins(viewMetaMixin, onLocaleChangeMixin) {
  fullPlatforms: IPlatformInfo[] = [];
  protected fetching: boolean = false;
  protected initFetches = [this.getFullPlatform];

  protected reFetches = [this.getFullPlatform];

  get platform(): IPlatformInfo {
    return this.$storage.getters.getPlatformInfo();
  }

  private getFullPlatform(): void {
    this.fetching = true;
    this.$services.platform
      .getPlatformInfo(i18n.locale)
      .then((response) => {
        this.fullPlatforms = response.data.results as IPlatformInfo[];
      })
      .catch((_) => {})
      .finally(() => {
        this.fetching = false;
      });
  }
  private UpdatePlatformInfo(): void {
    this.$storage.actions.updatePlatformInfo();
  }
}
